export type TemplateFormat = "story" | "post";

export type TemplateDef = {
  id: string;
  format: TemplateFormat;
  needsPlayerPhoto: boolean;
  isResult: boolean;
};

export type TemplateGroup = {
  label: string;
  templates: TemplateDef[];
};

const def = (id: string, format: TemplateFormat): TemplateDef => ({
  id,
  format,
  needsPlayerPhoto: id.endsWith("-Tp"),
  isResult: id.endsWith("-E"),
});

const suite = (prefix: string): TemplateDef[] => [
  def(`${prefix}-S`, "post"),
  def(`${prefix}-T`, "story"),
  def(`${prefix}-Tp`, "story"),
  def(`${prefix}-E`, "post"),
];

export const TEMPLATE_GROUPS: TemplateGroup[] = [
  {
    label: "Facetten",
    templates: [
      def("B1", "post"),
      def("B2", "post"),
      def("B3", "post"),
      def("B5", "post"),
      def("B4", "story"),
      def("B4b", "story"),
    ],
  },
  {
    label: "Pinselschrift",
    templates: [
      def("V1", "post"),
      def("V3b", "post"),
      def("V4", "post"),
      def("V5", "post"),
      def("V2", "story"),
      def("V3", "story"),
      def("V4s", "story"),
    ],
  },
  {
    label: "Wabenraster",
    templates: [
      def("A2", "post"),
      def("A1b", "post"),
      def("A4", "post"),
      def("A1", "story"),
      def("A3", "story"),
    ],
  },
  { label: "D9 Papierschnitt", templates: suite("D9") },
  { label: "D10 Grunge", templates: suite("D10") },
  { label: "D12 Anzeigetafel", templates: suite("D12") },
  { label: "D13 Gegner-Split", templates: suite("D13") },
  { label: "D5 Flutlicht", templates: suite("D5") },
  { label: "D6 Porträt-Panel", templates: suite("D6") },
  { label: "D8 Rotband", templates: suite("D8") },
];

export const ALL_TEMPLATES: TemplateDef[] = TEMPLATE_GROUPS.flatMap((g) => g.templates);

export const findTemplate = (id: string): TemplateDef | undefined =>
  ALL_TEMPLATES.find((t) => t.id === id);

export type ContentType = "spieltag" | "tor" | "ergebnis" | "aufstellung";

export const CONTENT_TYPES: { value: ContentType; label: string }[] = [
  { value: "spieltag", label: "Spieltag / Vorbericht" },
  { value: "tor", label: "Tor" },
  { value: "ergebnis", label: "Ergebnis" },
  { value: "aufstellung", label: "Aufstellung" },
];
